module.exports = __webpack_public_path__ + "982156ce72f134ecf84bc839350afef6.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/1000_r_50.mp3
// module id = 436
// module chunks = 0